import { useState } from 'react';
import { MemberDTO } from './data-types';
import Logins from './Logins';
import SearchForm from './SearchForm';


const newMemberDTO: MemberDTO = {
  identities: [],
  memberID: '',
  zipCode: '',
  isValidMemberID: false,
  isZipValid: false,
  isAccountRegistered: false,
  isValidAzureB2C: false,
  displayName: '',
  emailAddress: ''
}

function App() {
  const [memberDTO, setMemberDTO] = useState<MemberDTO>(newMemberDTO);
  console.log()
  return (
      !memberDTO.isValidMemberID || !memberDTO.isZipValid ?
      <SearchForm memberDTO={memberDTO} setMemberDTO={setMemberDTO} />
      :
      <Logins memberDTO={memberDTO} />
  );
}

export default App;
